import {SYMBOLS} from "../constants/configs";
import {CURRENCIES} from "../constants/currencies";
import {isMobile} from "pixi.js";

export const getRandomSymbolFrameName = () => SYMBOLS[Math.floor(Math.random() * (Object.keys(SYMBOLS).length - 1)) + 1];

export const getRandomBlurSymbolFrameName = () => "blur-"+SYMBOLS[Math.floor(Math.random() * (Object.keys(SYMBOLS).length - 1)) + 1];

export const universalClick = (pixiObject, callBack) => {
    pixiObject.on('click', callBack);
    pixiObject.on('touchend', callBack);
}

export const parseJwt = (token) => {
    if(!token){
        return {};
    }
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export const getAmountWithCurrency = (amount, currency, withSpace=true) => {
    currency = currency ? currency : "";
    const space = withSpace ? " " : "";
    if (CURRENCIES[currency] && CURRENCIES[currency].before) {
        return `${CURRENCIES[currency].symbol}${amount}`;
    } else if (CURRENCIES[currency]) {
        return `${amount}${space}${CURRENCIES[currency].symbol}`;
    } else {
        return `${amount}${space}${currency}`;
    }
}

export const isHorizontalScreen = () => {
    const canvasContainer = document.getElementById("canvasContainer");

    if (!canvasContainer) {
        return !isMobile.phone;
    }

    const {width, height} = canvasContainer.getBoundingClientRect();

    if (!isMobile.phone || width > height) {
        return true;
    }

    return false;
}

export const wait = (timeMS) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve("resolve");
        }, timeMS);
    });
}

export const isLocalStorageAvailable = () => {
    try {
        localStorage.getItem('isSoundOff');
        return true;
    } catch (error) {
        return false;
    }
}

export const getRandomNum = (startRange, endRange) => {
    if (startRange >= 0 && endRange > startRange) {
        return Math.floor(Math.random() * (endRange - startRange + 1)) + startRange;
    } else {
        console.error("Invalid input range");
        return null;
    }
}

export const calculateDistance = (point1, point2) => {
    const deltaX = point2.x - point1.x;
    const deltaY = point2.y - point1.y;

    return Math.sqrt(deltaX ** 2 + deltaY ** 2);
}

export const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
}

export const shuffleMatrix = (matrix) => matrix.map(row => shuffleArray([...row]));

////Domain
const getOriginDomain = () => {
  const splitted = window.location.origin.split(".");
  const origin = [splitted[splitted.length - 2], splitted[splitted.length - 1]].join(".");
  return origin;
};

export const getGameOriginDomain = () => {
  if (process.env.REACT_APP_ENVIRONMENT === "Development") return process.env.REACT_APP_ORIGIN_GAME_URL;
  return getOriginDomain();
};

export const getTranslationsOriginDomain = () => {
  if (["Development", "Staging"].includes(process.env.REACT_APP_ENVIRONMENT))
    return process.env.REACT_APP_ORIGIN_MAIN_URL;
  return getOriginDomain();
};
///